/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.8.2.0 (NJsonSchema v10.2.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import Collection from "../infrastructure/CollectionHelper";
import { productGroup } from "../router";

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
    * @param startDate (optional) 
    * @param endDate (optional) 
    * @param impersonated_User (optional) 
    * @param hOSTNAME (optional) localhost:3000
    * @return Success
    */
    getAgentProductionData(v: string, startDate?: Date | undefined, endDate?: Date | undefined, agentOrAgencyAWNs?: string[] | undefined,
        carrierNames?: string[] | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentReconcileProductionResponse> {
        let url_ = this.baseUrl + "/api/producersearch/v{v}/agent/getreconcileproduction?";
        //startDate = new Date(2016, 1, 1);
        //endDate = new Date(2021, 4, 1);
        //agentOrAgencyAWNs = ["0097107080"];
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (agentOrAgencyAWNs !== undefined && agentOrAgencyAWNs !== null)
            agentOrAgencyAWNs && agentOrAgencyAWNs.forEach(item => { url_ += "AgentOrAgencyAWNs=" + encodeURIComponent("" + item) + "&"; });
        if (carrierNames !== undefined)
            url_ += "CarrierNames=" + encodeURIComponent("" + carrierNames) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentProductionData(_response);
        });
    }

    protected processGetAgentProductionData(response: Response): Promise<AgentReconcileProductionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <AgentReconcileProductionResponse>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentReconcileProductionResponse>(<any>null);
    }

    /**
   * @param startDate (optional) 
   * @param endDate (optional) 
   * @param impersonated_User (optional) 
   * @param hOSTNAME (optional) localhost:3000
   * @return Success
   */
    getProductionSearchData(v: string, startDate?: Date, endDate?: Date, agentOrAgencyAWNs?: string[] | undefined,
        carrierNames?: string[] | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentCarriersAndProductsResponse> {
        let url_ = this.baseUrl + "/api/producersearch/v{v}/agent/getcarriersandproducts?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (agentOrAgencyAWNs !== undefined && agentOrAgencyAWNs !== null)
            agentOrAgencyAWNs && agentOrAgencyAWNs.forEach(item => { url_ += "AgentOrAgencyAWNs=" + encodeURIComponent("" + item) + "&"; });
        if (carrierNames !== undefined)
            url_ += "CarrierNames=" + encodeURIComponent("" + carrierNames) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProductionSearchData(_response);
        });
    }

    protected processGetProductionSearchData(response: Response): Promise<AgentCarriersAndProductsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <AgentCarriersAndProductsResponse>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentCarriersAndProductsResponse>(<any>null);
    }

    /**
    * @param agentId (required)
    * @param impersonated_User (optional) 
    * @param hOSTNAME (optional) localhost:3000
    * @return Success
    */
    getAgentAWNsData(v: string, agentId?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentOrAgencyDetails> {
        let url_ = this.baseUrl + "/api/producersearch/v{v}/agents/{agentorAgencyId}/agentoragencylookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentId === null)
            throw new Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ = url_.replace("{agentorAgencyId}", encodeURIComponent("" + agentId));

        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentAWNsData(_response);
        });
    }

    protected processGetAgentAWNsData(response: Response): Promise<AgentOrAgencyDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <AgentOrAgencyDetails>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentOrAgencyDetails>(<any>null);
    }

    /**
    * @param startDate (required) 
    * @param endDate (required) 
    * @param agentOrAgencyAWNs (required)
    * @param carrier (optional)
    * @param products(optional)
    * @param productCategories (optional)
    * @param productSubCategories (optional)
    * @param fileType (required)
    * @param impersonated_User (optional) 
    * @param hOSTNAME (optional) localhost:3000
    * @return Success
    */
    getAgentProductionReportData(v: string, startDate?: Date | undefined, endDate?: Date | undefined, agentOrAgencyAWNs?: string[] | undefined, carrier?: string | undefined,
        products?: string[] | null | undefined, productCategories?: string[] | null | undefined, productSubCategories?: string[] | null | undefined, fileType?: string | undefined,
        impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/producersearch/v{v}/reports/getproductionreconcilereport?";
        //startDate = new Date(2016, 1, 1);
        //endDate = new Date(2021, 4, 1);
        //agentOrAgencyAWNs = ["0097107080"];
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (agentOrAgencyAWNs !== undefined && agentOrAgencyAWNs !== null)
            agentOrAgencyAWNs && agentOrAgencyAWNs.forEach(item => { url_ += "AgentOrAgencyAWNs=" + encodeURIComponent("" + item) + "&"; });
        if (carrier !== undefined && carrier !== null)
            url_ += "CarrierName=" + encodeURIComponent("" + carrier) + "&";
        if (products !== undefined && products !== null)
            products && products.forEach(item => { url_ += "ProductNames=" + encodeURIComponent("" + item) + "&"; });
        if (productCategories !== undefined && productCategories !== null)
            productCategories && productCategories.forEach(item => { url_ += "ProductCategories=" + encodeURIComponent("" + item) + "&"; });
        if (productSubCategories !== undefined && productSubCategories !== null)
            productSubCategories && productSubCategories.forEach(item => { url_ += "ProductTypes=" + encodeURIComponent("" + item) + "&"; });
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        if (fileType !== undefined)
            url_ += "fileType=" + encodeURIComponent("" + fileType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentProductionReportData(_response);
        });
    }

    protected processGetAgentProductionReportData(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : <ReportFile>JSON.parse(_responseText, this.jsonParseReviver);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(<any>null);
    }

}

export interface TopCarriersModel {
    carrierName?: string | undefined;
    appCount?: number;
    annualizedPremium?: string;
}

export interface TopProductsModel {
    productName?: string | undefined;
    appCount?: number;
    annualizedPremium?: string;
}

export interface AgentCarriersAndProductsModel {
    agentorAgencyCount?: number;
    agentorAgencyNPN?: string;
    carrierCount?: number;
    productTypeCount?: number;
    businessUnit?: string | undefined;
    topCarriers?: TopCarriersModel[];
    carrierAnnualizedPremiumTotal?: string | undefined;
    topProducts?: TopProductsModel[];
    productAnnualizedPremiumTotal?: string | undefined;
}

export interface AgentCarriersAndProductsResponse {
    title?: string;
    data?: AgentCarriersAndProductsModel
}

export interface AppCountMonthYearModel {
    month?: number;
    currentYear?: number;
    previousYear?: number;
}

export interface AnnualizedPremiumMonthYearModel {
    month?: number;
    currentYear?: number;
    previousYear?: number;
}

export interface AgentReconcileProductionModel extends AgentCarriersAndProductsModel {
    appCountYearOverYear?: AppCountMonthYearModel[] | undefined;
    annualizedPremiumYearOverYear?: AnnualizedPremiumMonthYearModel[] | undefined;
}

export interface AgentReconcileProductionResponse {
    title?: string;
    data?: AgentReconcileProductionModel;
}

export interface ReportFile {
    title?: string | undefined;
    data?: string | undefined;
    contentType?: string | undefined;
    fileName?: string | undefined;
}

export interface AgentOrAgencyDetails {
    agentOrAgencyCount?: number;
    status?: string;
    message?: string;
    data?: Data;
}

export interface Data {
    agentOrAgencyAWNs?: string[];
    agentOrAgencyNPN?: string;
    carriers?: Carrier[];
}

export interface Carrier {
    CarrierId?: number;
    CarrierName?: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}